export default function ({ ...props }) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
            <path d="M13.125 16.751L6.875 10.501L13.125 4.25098" stroke="black" strokeWidth="1.5625" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}
